var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInboxIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.434 11.6222L20.97 4.68889C20.277 3.05556 18.682 2 16.922 2H7.07796C5.31801 2 3.72296 3.05556 3.00801 4.75556L0.566007 11.6222C0.521904 11.7431 0.499553 11.8711 0.500007 12V17.5556C0.500007 20.0111 2.46896 22 4.90001 22H19.1C21.531 22 23.5 20.0111 23.5 17.5556V12C23.5 11.8667 23.478 11.7444 23.434 11.6222ZM5.05401 5.56662C5.40601 4.75551 6.19796 4.22222 7.07796 4.22222H16.922C17.802 4.22222 18.594 4.75551 18.924 5.51107L20.97 11.8889H15.6553C15.0503 11.8889 14.5553 12.3889 14.5553 13C14.5553 14.2222 13.5 15.5 12 15.5C10.5 15.5 9.5 14.2222 9.5 13C9.5 12.3889 9.005 11.8889 8.4 11.8889H3.00801L5.05401 5.56662Z",
    fill: "#267072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIconActive);
export default __webpack_public_path__ + "static/media/inbox_icon_active.b8f6140fbc554aebd2b15106a6f3534a.svg";
export { ForwardRef as ReactComponent };